import React from 'react';
import LegacyText, { TextProps } from './Text.legacy';
import AlphaText from './Text.alpha';

const Component = process.env.IS_LEGACY ? LegacyText : AlphaText;
export default Component as React.FC<TextProps>;
export type { TextProps };
